import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { environment } from '@y42/environment';
import { ORG_API_URL_PARAM } from '@y42/model';

@UntilDestroy()
@Injectable()
export class Y42ChatConfigService {
  get chatApiUrl() {
    return `${environment.url.chat_api}/${ORG_API_URL_PARAM}/chat_sessions`;
  }
}
